const Home : React.FC = () =>
<div>
    <h2>Welcome to the home of the Justice Department of Fakelandia.</h2>
    <p>Here you can browse a list of recent misdemeanours committed by our citizens, or you can confess to your own misdemeanour.</p>

</div>

;

export default Home;
